init_switcher = ->

    ###
      Switcher handlers
    ###
    switchers = $(document).find('input[type="checkbox"][data-switch-target]')

    switcher_mode = (switcher, state) ->
        target_path = switcher.attr 'data-switch-target'
        controls = $(document).find "[data-switch-handler='#{target_path}']"

        controls.each ->
            control = $ @

            switch_handler = (state_of) ->
                if state_of
                    control.removeClass 'disabled'
                    control.removeAttr 'disabled'
                else
                    control.addClass 'disabled'
                    control.attr 'disabled', 'disabled'

            inversion = switcher.attr 'data-switch-inversion'

            if typeof inversion != typeof undefined and inversion != false
                switch_handler !state
            else
                switch_handler state


    ###
      for bootstrap switcher variant
    ###
    switchers.filter('.on-off').each (i, checkbox) ->
        checkbox = $ checkbox
        checkbox.bootstrapSwitch()
        checkbox.on 'switchChange.bootstrapSwitch', (event, state) ->
            switcher = $ @
            switcher_mode switcher, state

    ###
      for naive checkbox
    ###
    switchers.filter(':not(.on-off)').each (i, checkbox) ->
        checkbox = $ checkbox
        checkbox.on "change", ->
            switcher = $ @
            checked = switcher.is(':checked')
            inversion = switcher.attr 'data-switch-inversion'
            unless checked then state = false else state = true
            switcher_mode switcher, state

$ ->
    init_switcher()
